import React, { useState } from "react";
import t, { changeLanguage } from "../../components/I18N/TranslateHelpers";
import {
    Control,
    FieldValues,
    useFieldArray,
    UseFormGetValues,
    UseFormRegister,
    UseFormSetValue,
} from "react-hook-form";
import { store } from "app/store";
import { getAgreement, getUserAgreedAgreement, getUserDownloadedAgreement, uploadAgreementFile } from "features/Slice/AgreementSlice";
import { useSelector } from "react-redux";
import { RootState } from "app/RootReducer";
import { Agreement } from "features/Entity/Agreement";

interface ComponentProps {
    agreement: Agreement;
    applicationFormId: string;
    applicationFormCultureCode: string;
    register: UseFormRegister<FieldValues>;
    setValue: UseFormSetValue<FieldValues>;
    getValues: UseFormGetValues<FieldValues>;
    isReadOnly: boolean;
    index: number;
    sectionId: number;
    control: Control<FieldValues, any>,
}

const AgreementUploadField: React.FC<ComponentProps> = ({
    agreement,
    applicationFormId,
    applicationFormCultureCode,
    register,
    setValue,
    getValues,
    isReadOnly,
    index,
    sectionId, 
    control
}) => {
    const isPostSuccess = useSelector((state: RootState) => state.agreementRdc.isPostSuccess);
    const [uploadedFilename, setUploadedFilename] = useState<string | null>(agreement.filenameUploaded && agreement.filenameUploaded.length > 0 ? agreement.filenameUploaded : null);

    React.useEffect(() => {
        if (isPostSuccess) {
            const uploadingFilelist = getValues(`agreement.${index}.File`);

            if (uploadingFilelist) {
                try {
                    const uploadingFilename = (uploadingFilelist as FileList).item(0);

                    if (uploadingFilename && uploadingFilename.name) {
                        setUploadedFilename(uploadingFilename.name);
                    }
                }
                catch (err) { }
            }
        }
    }, [isPostSuccess]);
    const agreedOn: Date | null =
    agreement.hasAgreedOn
        ? new Date(agreement.hasAgreedOn as unknown as string | number | Date)
        : null;

    const agreedOnLabel = agreedOn
    ? `${agreedOn.toLocaleDateString("fr-BE")} ${agreedOn.toLocaleTimeString("fr-BE", {
        hour: "2-digit",
        minute: "2-digit",
        })}`
  : "";

    return (
        <li key={agreement.agreementUID} className="task row">
            <input
                type="hidden"
                {...register(`agreements.${index}.ValueString`)}
                value={agreement.agreementUID}
                />
            <h4 className="task-label mw-40 col-md-3">{agreement.title}</h4>
            {
                agreement.description &&
                <span className="col-md-3">{agreement.description}</span>
            }
            <div className={agreement.description ? "col-md-2" : "col-md-6"}>
                {
                agreedOn  !== null && agreement.hasAgreed ? (
                    <span className="badge rounded-pill badge-info">
                        {t("agreed_agreement_info", {time: agreedOnLabel,author : agreement.agreedBy })}
                    </span>
                ) : (
                    <div className="form-check form-check-inline checkbox checkbox-primary">
                        <input
                            className="form-check-input"
                            id={`agree-${agreement.agreementUID}.${index}`}
                            type="checkbox"
                            defaultChecked={agreement.hasAgreed}
                            {...register(`agreements.${index}.Checked`)}
                        />
                        <label className="form-check-label" htmlFor={`agree-${agreement.agreementUID}.${index}`}>
                            <span dangerouslySetInnerHTML={{ __html: t('i_accept_term_agreement') }} />
                        </label>
                    </div>
                )
            }
            </div>

            <div className="col-md-8">
                <div className="d-flex flex-row">
                    {agreement.filename && agreement.filename.length > 0 && (
                        <button
                            type="button"
                            onClick={() =>
                                store.dispatch(
                                getAgreement(agreement, applicationFormCultureCode, agreement.filename!)
                                )
                            }
                            className="btn btn-primary btn-sm job-apply-btn px-2 me-2"
                            >
                            <i className="icofont icofont-download-alt"></i> {t("download_agreement")}
                        </button>
                    )}

                    {agreement.filenameUploaded && agreement.filenameUploaded.length > 0 && (
                        <button
                            type="button"
                            onClick={() => {
                            if (agreement.filenameUploaded) {
                                store.dispatch(
                                getUserDownloadedAgreement(
                                    applicationFormId,
                                    agreement.agreementUID,
                                    agreement.filenameUploaded
                                )
                                );
                            }
                            }}
                            className="btn btn-gray btn-sm px-2 me-2"
                            >
                            <i className="icofont icofont-download-alt mr-2"></i>{" "}
                            {t("download_signed_agreement")}
                        </button>
                    )}

                    {agreement.fileNameAgreed && agreement.fileNameAgreed.length > 0 && (
                        <button
                            type="button"
                            onClick={() =>
                                store.dispatch(
                                getUserAgreedAgreement(applicationFormId, agreement.agreementUID, agreement.fileNameAgreed!)
                                )
                            }
                            className="btn btn-gray btn-sm px-2 me-2"
                            >
                            <i className="icofont icofont-download-alt"></i> {t("download_agreed_agreement")}
                        </button>
                    )}
                </div>
            </div>
        </li>
    );
};

export default AgreementUploadField;
